module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/6@2x_1f48a5bbbe113a14dfce4dc4d6721749.png";